export default __webpack_public_path__ + "static/media/1709.d81e8cb9.png";